import {
    useMemo, useState,
} from 'react'
import noop from 'lodash/noop'
import FormWithControls from 'app/shared-components/FormWithControls'
import {
    RequestConfig,
} from 'app/types/request.types'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import useScrollToForm from 'app/hooks/useScrollToForm'

import useEnumValues from 'app/hooks/useEnumValues'
import {
    LaneDetails,
} from 'app/Apps/Pricing/Pricing.types'
import useHistoryNavigation from 'app/hooks/useHistoryNavigation'

import {
    LaneStatus,
} from 'app/enums/label.enums'
import useStyles from './LaneForm.styles'
import laneFormFields, {
    generalColumn,
} from './LaneForm.fields'

const defaultProps = {
    data: {} as LaneDetails,
    onSuccess: noop,
    onCancel: noop,
    customButtons: undefined,
}

const LaneForm = ({
    disabled = false,
    data,
    onCancel,
    onSuccess,
    requestParam,
    customButtons,
    changeStatusDisabled = false,
}: Readonly<{
    disabled?: boolean,
    data?: LaneDetails,
    onSuccess?: (...args: any[]) => void,
    onCancel?: (...args: any[]) => void,
    requestParam: RequestConfig,
    customButtons?: JSX.Element[],
    changeStatusDisabled?: boolean,
}>) => {
    const {
        action,
    } = useHistoryNavigation()
    const getAllowedValues = useEnumValues()
    const {
        classes,
    } = useStyles()
    const [
        updatedValues,
        setUpdatedValues,
    ] = useState<LaneDetails>(null)
    const scrollToForm = useScrollToForm(String(data?.id), action === 'copy')

    const exists = Boolean(data?.id)

    const formValue = useMemo(() => {
        return {
            ...data,
            ...updatedValues,
        }
    }, [
        data,
        updatedValues,
    ])

    const isImplementedStatus = useMemo(() => {
        return exists && data?.laneStatus === LaneStatus.IMPLEMENTED
    }, [
        data?.laneStatus,
        exists,
    ])

    const displayedFields = useMemo(() => {
        if (exists) {
            return [
                ...laneFormFields(isImplementedStatus),
                generalColumn({
                    originalStatus: data?.laneStatus,
                    getAllowedValues,
                    isImplementedStatus: changeStatusDisabled || isImplementedStatus,
                }),
            ]
        }
        return laneFormFields(isImplementedStatus)
    }, [
        exists,
        isImplementedStatus,
        data?.laneStatus,
        getAllowedValues,
        changeStatusDisabled,
    ])

    const fields = useFieldsWithClassName(displayedFields, classes)

    return (
        <div
            className={classes.root}
            ref={scrollToForm}
        >
            <FormWithControls
                disabled={disabled}
                name="Lane"
                fields={fields}
                value={formValue}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                setExternalValue={setUpdatedValues}
                onCancel={onCancel}
                onSuccess={onSuccess}
                exists={exists}
                requestParams={requestParam}
                customButtons={customButtons}
                cancelEnabled
            />
        </div>
    )
}

LaneForm.defaultProps = defaultProps

export default LaneForm
